import { render, staticRenderFns } from "./investment-info-card.component.vue?vue&type=template&id=d54c7a50"
import script from "./investment-info-card.component.vue?vue&type=script&lang=js"
export * from "./investment-info-card.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports